import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-303" data-mp="2urlqfht25jf">
      <div className="max-w-5xl mx-auto" data-id="element-304" data-mp="2tzoz1ch21rk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-305" data-mp="2x5daeda0zm8">
          <div data-id="element-306" data-mp="3u2x1373l005v">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-5 text-navy uppercase" data-id="element-307" data-mp="3g9xpvhau0s44">
              Let Your Student See the Skill Before Performing It
            </h2>
            <p className="text-xl font-semibold text-navy mb-1" data-id="element-308" data-mp="3l6eaw2mqiqcz">Scuba diving is practical.</p>
            <p className="text-xl font-semibold text-cta mb-5" data-id="element-309" data-mp="36dud7hictb2x">
              Your teaching material should be practical too.
            </p>
            <p className="text-ink leading-relaxed mb-3" data-id="element-310" data-mp="eqsn9rhhxlrv">
              <span className="font-semibold text-navy" data-id="element-311" data-mp="etex5xrv0dd9">
                Scuba Diving Instructor Ready is 100% visual.
              </span>
            </p>
            <p className="text-ink leading-relaxed" data-id="element-312" data-mp="nqyyf6pq29nv">
              It uses visual teaching resources throughout the complete 6-in-1 system to make
              underwater skills easier for instructors to explain and easier for students to
              understand.
            </p>
          </div>

          <div className="bg-mist border border-aqua/30 rounded-2xl p-6" data-id="element-313" data-mp="3n8ot0o55omcl">
            <p className="text-sm font-bold text-ocean uppercase tracking-wider mb-4" data-id="element-314" data-mp="4txtflw649jx">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-315" data-mp="14nwvsvkx6s">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-316" data-mp="38go8l6fhd7a8">
                  <CheckCircle2 size={16} className="text-aqua shrink-0 mt-0.5" data-id="element-317" data-mp="34ge5c1j2ouz2" />
                  <span data-id="element-318" data-mp="17f8ec00htgrh">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-serif font-extrabold text-navy mt-14" data-id="element-319" data-mp="1cdjmm6b53j7l">
          <span className="text-cta" data-id="element-320" data-mp="1h6utu8jv6201">100% VISUAL.</span> PRACTICAL. READY TO TEACH.
        </p>
      </div>
    </section>;
}